import React, { useState, useContext } from "react";
import { DataProvider } from './DataProvider';
import Dataconnectionwrapper from './Dataconnectionwrapper'

const DataConnect = ({ variableMode = false }) => {
  
  return (
	<DataProvider variableMode={variableMode}>
		<Dataconnectionwrapper variableMode={variableMode} />
	</DataProvider>
  );
};

export default DataConnect;
